// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header_JjIeR","labels":"Header_labels_1dynS","label":"Header_label_M34h0","backLabel":"Header_backLabel_jXA3T","closeButton":"Header_closeButton_1iDDW"};